<template>
  <div class="form-element">
    <label class="form-element__title" v-if="title">{{ title }}</label>
    <input
      class="form-element__input"
      :class="classObject"
      :placeholder="placeholder"
      autocomplete="off"
      @keyup="changed"
      v-model.trim="val"
    />
    <div class="form-element__message" v-if="message">{{ message }}</div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: null,
    },
    placeholder: {
      type: String,
      default: "",
    },
    isSecondary: {
      type: Boolean,
      default: false,
    },
    isError: {
      type: Boolean,
      default: false,
    },
    isHalf: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: null,
    },
    message: {
      type: String,
      default: null,
    },
    isBorder: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      val: this.value,
    };
  },
  computed: {
    classObject: function () {
      let list = {
        "-secondary": this.isSecondary,
        "-error": this.isError,
        "-half": this.isHalf,
        "-border": this.isBorder,
      };

      return list;
    },
  },
  watch: {
    // value: function (val) {
    //   this.val = val
    // }
  },
  methods: {
    changed: function (e) {
      let isValid = this.validateEmail(e.target.value);

      if (isValid) return this.$emit("input", e.target.value);

      return this.$emit("input", null);
    },
    validateEmail: function (val) {
      const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(val).toLowerCase());
    },
  },
};
</script>